import EnabledCheckIcon from '@/components/Icons/EnabledCheckIcon';
import UploadIcon from '@/components/Icons/UploadIcon';
import { DROPZONE_ACCEPT, MAX_FILE_SIZE, boxStyles } from '@/constants/firstPartyData/fileDropZone';
import { Box, CircularProgress } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { DragDropMessage, FileUploadedMessage } from './messages';

interface FileDropZoneProps {
  setUploadedFile: (file: File) => void;
  watch: (field: string) => File | undefined;
}

const FileDropZone: React.FC<FileDropZoneProps> = ({ setUploadedFile, watch }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (!acceptedFiles.length) {
        toast.error('Load only CSV file');
        return;
      }
      setIsLoading(true);
      const file = acceptedFiles[0];

      const fileName = file.name || '';
      const lastDotIndex = fileName.lastIndexOf('.');
      const baseName = lastDotIndex > 0 ? fileName.slice(0, lastDotIndex) : fileName;
      if (/[\s.]/.test(baseName)) {
        setIsLoading(false);
        toast.error('Error: Please remove space or period from file name and re-upload.');
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        setIsLoading(false);
        toast.error('File size exceeds 20MB limit');
        return;
      }
      setUploadedFile(file);
      setIsLoading(false);
    },
    [setUploadedFile],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: DROPZONE_ACCEPT,
  });

  const uploadedFile = watch('file');

  return (
    <>
      {!uploadedFile ? (
        <Box
          {...getRootProps()}
          sx={{
            ...boxStyles,
            backgroundColor: '#F8F8F8',
          }}
        >
          {isLoading ? (
            <CircularProgress size={40} />
          ) : (
            <>
              <input {...getInputProps()} />
              <div className='bg-[#E6E6E7] rounded-lg p-2.5 '>
                <UploadIcon />
              </div>
              <DragDropMessage />
            </>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            ...boxStyles,
            backgroundColor: 'rgba(44, 110, 73, 0.15)',
          }}
        >
          <EnabledCheckIcon width={40} height={40} />
          <FileUploadedMessage />
        </Box>
      )}
    </>
  );
};

export default FileDropZone;
